import { render, staticRenderFns } from "./UnionRulesetGrid.vue?vue&type=template&id=6b1179d8&"
import script from "./UnionRulesetGrid.vue?vue&type=script&lang=js&"
export * from "./UnionRulesetGrid.vue?vue&type=script&lang=js&"
import style0 from "./UnionRulesetGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports